import React from "react";
import Banner from "../components/Banner";
import MenuList from "../components/MenuList";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import FAQ from "../components/FAQ";
import Testimonials from "../components/Testimonials";

const imageUrls = [
  "banner.webp",
  "banner1.avif",
  "banner2.webp",
  "banner3.webp",
  "banner4.jpg",
]; // Array of images

const Home = () => {
  return (
    <Container maxWidth="xl" sx={{ mt: 12 }}>
      <Banner imageUrls={imageUrls} />
      <Typography variant="h5" sx={{ mt: 4 }}>
        Hot Meals Today
      </Typography>
      <MenuList filter="all" />
      <Testimonials />
      <FAQ />
    </Container>
  );
};

export default Home;
